import React, {Component} from 'react';

import Layout from '../../components/Layout'
import MyDorm from '../../pages/MyDorm'
import Loading from '../../components/Base/Loading'

/* Container for My Posts page */

class MyDormContainer extends Component {
	state = {
		dormList: null,
		width: 0,
		height: 0,

	};

	componentDidMount() {
		this.updateWindowDimensions();
		window.addEventListener('resize', this.updateWindowDimensions);
	}

	updateWindowDimensions = () => {
		this.setState({width: window.innerWidth, height: window.innerHeight});
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this.updateWindowDimensions);
		// this.listener()
	}


	render() {
		const {dormList, width} = this.state;
		const {profile} = this.props;

		return (
			<Layout {...this.props} noSideBar>
				{profile === null || profile === undefined ? <Loading/> :
					<MyDorm {...this.props} width={width} students={dormList}/>

				}

			</Layout>
		);
	}
}


export default MyDormContainer;
